var map = {
	"./facebook.svg": 20,
	"./github.svg": 21,
	"./google-play.svg": 22,
	"./google-plus.svg": 23,
	"./instagram.svg": 24,
	"./linkedin.svg": 25,
	"./skype.svg": 26,
	"./twitter.svg": 27,
	"./whatsapp.svg": 28,
	"./youtube.svg": 29
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*$
// module id = 19
// module chunks = 0